module.exports = __webpack_public_path__ + "static/media/06-_DSC1155.4300a7c0.jpg";